import React from 'react'
import PropTypes from 'prop-types'
import Smartview from 'widgets/smartviews/Smartview'
import {
  ForEachModel,
  FormContext,
  ReadOnlyCollection,
  ValueToCollection,
  WhenCollectionIsNotEmpty
} from '@morningtrain/react-resources'
import { Translation, Translator } from '@morningtrain/react-translations'
import InventoryOrderSmartviewFooter from 'widgets/inventory/InventoryOrderSmartviewFooter'
import { VerticalList } from 'ui/layouts'
import InventoryDeliveryNoteSmartviewItem from 'widgets/inventory/InventoryDeliveryNoteSmartviewItem'
import OrderCategoryPriceSummary from 'widgets/smartviews/inventory/OrderCategoryPriceSummary'

export default function DeliveryNoteOverviewSmartview ({ formRef }) {
  return (
    <FormContext.Provider value={formRef}>
      <Translator namespace='smartviews.order_overview'>
        <Smartview header={<Translation name='titles.delivery_note' />} footer={<InventoryOrderSmartviewFooter />}>
          <ReadOnlyCollection resourceName='inventory.supplier' operationName='items'>
            <VerticalList>
              <ForEachModel>
                <OrderCategoryPriceSummary>
                  <ValueToCollection name='collection'>
                    <WhenCollectionIsNotEmpty>
                      <ForEachModel>
                        <InventoryDeliveryNoteSmartviewItem />
                      </ForEachModel>
                    </WhenCollectionIsNotEmpty>
                  </ValueToCollection>
                </OrderCategoryPriceSummary>
              </ForEachModel>
            </VerticalList>
          </ReadOnlyCollection>
        </Smartview>
      </Translator>
    </FormContext.Provider>
  )
}

DeliveryNoteOverviewSmartview.propTypes = {
  formRef: PropTypes.any.isRequired
}
